<template>
  <div>
    <div style="width: 100%" :style="{ height: height }" v-bind:id="id"></div>
  </div>
</template>

<script>
import chartResize from '@/mixin/chart-resize'
import { getUUID } from '../../../../../utils/util'
// import { TooltipComponent, LegendComponent } from 'echarts/components'
// import { PieChart } from 'echarts/charts'
// import { CanvasRenderer } from 'echarts/renderers'
// echarts.use([TooltipComponent, LegendComponent, PieChart, CanvasRenderer])
export default {
  mixins: [chartResize],
  name: 'BarLineEchart',
  components: {},
  data() {
    return {
      id: getUUID(),
    }
  },
  myChart: null,
  unwatch: null,
  props: {
    // id: {
    //   type: String,
    //   default: ''
    // },
    data: {
      type: Object,
      default: null,
    },
    height: {
      type: String,
      default: '200px',
    },
  },
  methods: {
    drawRingGraph() {
      let _this = this
      this.myChart = echarts2.init(document.getElementById(_this.id))
      this.unwatch = this.$watch(
        'data',
        function (newvalue, oldvalue) {
          if (newvalue) {
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    },
    set(data) {
      var option
      var data = this.data
      
      option = {
        color: [
          new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#18B0DD' }, //柱图渐变色
            { offset: 1, color: '#2A80E8' }, //柱图渐变色
          ]),
          '#0071FB',
          '#FB7800',
        ],
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,0.7)',
          textStyle: {
            color: '#FFFFFF',
          },
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
          formatter: function (params) {
            console.log(params)
            var allData = 0
            var result = ''
            result += params[0].marker + params[0].name + '<br>'
            for (let i = 0; i < params.length; i++) {
              if (!params[i].data) {
                params[i].data = '-'
              }
              if (params[i].seriesName == '环比') {
                params[i].data != '-'
                  ? (result += '&nbsp&nbsp&nbsp' + params[i].seriesName + ' ：' + params[i].data + '%<br>')
                  : (result += '&nbsp&nbsp&nbsp' + params[i].seriesName + ' ：' + params[i].data + '<br>')
              } else {
                result += '&nbsp&nbsp&nbsp' + params[i].seriesName + ' ：' + params[i].data + '<br>'
              }
            }

            return result
          },
        },
        grid: {
          top: '32px',
          left: '40px',
          right: '43px',
          bottom: 30,
        },
        legend: {
          data: ['同比', '环比'],
        },
        xAxis: [
          {
            type: 'category',
            data: data.xData,
            axisPointer: {
              type: 'shadow',
            },
            axisLabel: {
              formatter: '{value}',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '吨',
            position: 'left',
            axisTick: {
              show: true, //去除刻度线
            },
            axisLine: {
              show: true,
            },
          },
          {
            type: 'value',
            position: 'right',
            axisLabel: {
              formatter: '{value} %',
            },
          },
        ],

        series: [
          {
            name: '售水量',
            type: 'bar',
            data: data.saleData,
            barWidth: 10,
          },
          {
            name: '同比',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            data: data.tData,
          },
          {
            name: '环比',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            data: data.hData,
          },
        ],
      }

      this.myChart.setOption(option)
      this.chartEleResizeListener()
    },
  },
  mounted() {
    this.drawRingGraph()
  },
  created() {},
  beforeDestroy() {
    if (this.unwatch) {
      this.unwatch()
      this.unwatch = null
    }
    if (!this.myChart?.isDisposed) {
      this.myChart.dispose()
    }
  },
}
</script>
<style lang="less" scoped>
</style>
